import { TypographyV3 } from '@jouzen/ecom-components';
import type { RichTranslationValues } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import RichText from '@/app/components/RichText';

interface MembershipAccordionContentProps {
  readonly contentMsgKey: MessageKey;
  readonly dataCy?: string;
  readonly values?: RichTranslationValues;
}

const MembershipAccordionContent = ({
  contentMsgKey,
  values,
  dataCy,
}: MembershipAccordionContentProps) => {
  return (
    <TypographyV3
      color={'light'}
      className="text-sm lg:text-xl"
      data-cy={dataCy}
    >
      <RichText messageKey={contentMsgKey} tValues={values} />
    </TypographyV3>
  );
};
export default MembershipAccordionContent;
